import React from 'react';
import { FaTachometerAlt, FaUsers, FaCode, FaFileAlt, FaCog, FaSignOutAlt } from 'react-icons/fa';
import { Link } from 'react-router-dom';


const Sidebar = () => {
 return (
 <div className="bg-bgMain text-gold w-64 min-h-screen p-6 flex flex-col justify-between">
 <div>
 <h1 className="text-2xl font-bold text-white mb-8">The Skill Genie Admin</h1>
 <ul className="space-y-6 text-white text-md">
 <li title="Dashboard" className="flex items-center gap-3 hover:text-gold"><FaTachometerAlt /> Dashboard</li>
 <li title="Users" className="flex items-center gap-3 hover:text-gold"><FaUsers /> Users</li>
 <li title="Support desk" className="flex items-center gap-3 hover:text-gold"><FaUsers /> Support desk</li>
 <Link to="/techgrid" title="Technologies">
 <li className="flex items-center gap-3 hover:text-gold mt-5">
 <FaFileAlt /> Technologies
 </li>
 </Link>
 
 
 <li title="Settings" className="flex items-center gap-3 hover:text-gold"><FaCog /> Settings</li>
 </ul>
 </div>
 <div title="Logout" className="text-white flex items-center gap-2 hover:text-gold cursor-pointer">
 <FaSignOutAlt /> Logout
 </div>
 </div>
 );
};

export default Sidebar;



